import { render, staticRenderFns } from "./Devoluciones.vue?vue&type=template&id=63faeb5a&lang=pug"
import script from "./Devoluciones.vue?vue&type=script&lang=js"
export * from "./Devoluciones.vue?vue&type=script&lang=js"
import style0 from "./Devoluciones.vue?vue&type=style&index=0&id=63faeb5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports